module.exports = __webpack_public_path__ + "img/horizontal_4_5_3009.2535d43e.png";